<script setup>import { ref as _ref, computed as _computed } from 'vue';

  import TagLabel from "./tag-label.vue";
  import TagEditDialog from "./tag-edit-dialog.vue";
  import SidePanel from "./side-panel.vue";

  import { vElementVisibility } from "@vueuse/components";

  import { useTagEditController } from "./lib/tag-edit-controller.js";
  import { isNil, sortBy } from "lodash-es";

  const props = defineProps({
    tagStore: { type: Object, required: true },
  });

  const editingTag = _ref(null);

  const tagEditController = useTagEditController({
    store: props.tagStore,
    editingTag: (editingTag),
    tags: null,
  });

  const panel = _ref(null);

  const show = () => {
    panel.value.showModal();
  };

  const close = () => {
    panel.value.close();
  };

  const requestCount = (tag) => {
    if (!isNil(tag?.name)) {
      props.tagStore.requestCount({ name: tag.name });
    }
  };

  const sortedTags = _computed(() => {
    return sortBy(props.tagStore.allTags, (t) => t.name.trim().toLowerCase());
  });
</script>

<template>
  <a href="" @click.prevent="show">Manage Tags...</a>
  <SidePanel ref="panel">
    <div
      class="is-flex is-justify-content-space-between is-align-items-center py-4 pr-3 has-background-white"
      style="position: sticky; top: 0; z-index: 2"
    >
      <h2 class="is-size-4">Manage Tags</h2>
      <div>
        <button class="delete" aria-label="close" @click="close"></button>
      </div>
    </div>
    <TagEditDialog
      v-if="editingTag"
      :id="editingTag.id"
      :name="editingTag.name"
      :color="editingTag.color"
      :count="editingTag.count"
      @save="(tag) => tagEditController.save(tag)"
      @cancel="(tag) => tagEditController.cancel(tag)"
      @destroy="(tag) => tagEditController.destroy(tag)"
    />

    <div class="is-flex gap-2 is-flex-direction-column mb-2 pr-3" style="overflow-x: scroll">
      <div
        v-for="(tag, index) in sortedTags"
        :key="index"
        v-element-visibility="(state) => state && requestCount(tag)"
        class="is-flex is-justify-content-space-between"
      >
        <span class="is-flex gap-3 is-align-items-center">
          <TagLabel :name="tag.name" :color="tag.color" :can-remove="false" />
          <span v-if="!isNil(tag.count)" class="has-text-info is-small">
            {{ tag.count }} item{{ tag.count === 1 ? "" : "s" }}
          </span>
        </span>
        <button type="button" class="button" @click="tagEditController.show(tag)">Edit</button>
      </div>
    </div>
  </SidePanel>
</template>
